<template>
  <div>
    <b-card no-body class="mb-0">
      <div class="m-2 mt-3">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col cols="12" md="6" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
            <label>Afficher</label>
            <v-select v-model="perPage" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="pageOptions"
              :clearable="false" class="per-page-selector d-inline-block mx-50" />
            <label>entrées</label>
          </b-col>

          <!-- Search -->
          <b-col cols="12" md="2">
            <div class="d-flex align-items-center justify-content-end">

            </div>
          </b-col>

          <!-- Filter On -->
          <b-col cols="12" md="4">
            <b-input-group size="sm">
              <b-form-input id="filterInput" v-model="filterInput" type="search" placeholder="Saisissez votre recherche"
                @keyup="applyFilter" />
              <b-input-group-append>
                <b-button @click="applyFilterEnter">
                  Rechercher
                </b-button>
              </b-input-group-append>
            </b-input-group>
            <!-- <b-form-group
              v-slot="{ ariaDescribedby }"
              v-model="sortDirection"
              description="Laissez tout décoché pour filtrer sur toutes les données"
              class="mt-0"
            >
              <b-form-checkbox-group
                v-model="filterOn"
                :aria-describedby="ariaDescribedby"
                class="mt-1 mb-0"
              >
                <b-form-checkbox
                  class="mb-1"
                  value="codearticle"
                >
                  Code article
                </b-form-checkbox>
                <b-form-checkbox
                  class="mb-1"
                  value="nom"
                >
                  Nom
                </b-form-checkbox>
              </b-form-checkbox-group>
            </b-form-group> -->
          </b-col>
        </b-row>

        <!-- Tableau -->
        <b-row>
          <b-col cols="12">
            <b-table id="datatables" class="datatables mt-4 mb-4" :items="filtered" :fields="fields" stacked="md"
              :per-page="perPage" :current-page="currentPage" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection" :filter="filter" :filter-included-fields="filterOn" striped small
              @filtered="onFiltered" @row-clicked="selectedCol">
              <!-- Filter top column -->
              <template slot="top-row">
                <td class="M-filter">Filtres : </td>
                <td class="M-filter"><b-form-input v-model="filters['codearticle']" placeholder="Code article"
                    class="d-inline-block mr-1" /></td>
                <td class="M-filter"><b-form-input v-model="filters['nom']" placeholder="Nom"
                    class="d-inline-block mr-1" /></td>
                <td class="M-filter"><b-form-select v-model="filters['categorie']" :options="categoriesName" /> </td>
                <td class="M-filter"><b-form-select v-model="filters['fournisseur']" :options="souscategoriesName" />
                </td>
              </template>

              <!-- IMAGES -->
              <template #cell(image)="data">
                <img :src=data.value height="40" width="auto" />
              </template>

              <!-- PRIX -->
              <template #cell(prix)="data">
                <span>{{ parseFloat(data.value).toFixed(2) }} {{ setting.devise }} HT </span><br />
                <span style="font-size: 0.8em;">{{ parseFloat(data.value + (data.value * (data.item.tva
              / 100))).toFixed(2) }} {{ setting.devise }} TTC</span>
              </template>

              <!-- FAMILLES -->
              <template #cell(categoriesarticles)="data">
                <span v-for="(famille, familleindex) in data.item.categoriesarticles" :key="familleindex">
                  <span v-if="familleindex != data.item.categoriesarticles.length - 1">,</span>
                </span>
              </template>

              <!-- Column: Actions -->
              <template #cell(actions)="data">
                <b-button v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                  :to="{ name: 'viewarticle', params: { id: data.item.key } }" variant="flat-success"
                  class="btn-icon rounded-circle">
                  <feather-icon icon="EyeIcon" />
                </b-button>
              </template>
            </b-table>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start" />
          <!-- Pagination -->
          <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" first-number last-number
              class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BButton,
  BTable,
  BLink,
  BDropdown,
  BDropdownItem,
  BPagination,
  BFormGroup,
  BFormCheckbox,
  BFormCheckboxGroup,
  BImg,
  BFormSelect,
  BFormSelectOption,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import PouchDB from 'pouchdb'
import moment from 'moment'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BButton,
    BTable,
    BLink,
    BDropdown,
    BDropdownItem,
    BPagination,
    BFormGroup,
    BFormCheckbox,
    BFormCheckboxGroup,
    BImg,
    BFormSelect,
    BFormSelectOption,
    vSelect,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      fields: [],
      filters: '',
      products: [],
      fournisseurs: [],
      categoriesName: [],
      souscategoriesName: [],
      categoriesarticles: [],
      selectedCategoriesArticle: [],
      selectedFournisseur: [],
      isLoading: true,
      drawer: true,
      perPage: 100,
      currentPage: 1,
      totalRows: 1,
      filterInput: '',
      pageOptions: [50, 100, 200, 500, 1000],
      filter: null,
      outlined: true,
      filterOn: [],
      sortBy: 'codearticle',
      sortDirection: 'asc',
      sortDesc: false,
      localDB: new PouchDB(localStorage.getItem('database')),
      remoteDB: new PouchDB(localStorage.getItem('url') + '/' + localStorage.getItem('database')),
      setting: JSON.parse(localStorage.setting),
      commercial: JSON.parse(localStorage.commercial),
    }
  },
  computed: {
    /**
      * Total no. of records
      */
    rows() {
      return this.products.length
    },
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
    filtered() {
      const filtered = this.products.filter(item => {
        return Object.keys(this.filters).every(key =>
          String(item[key].toLowerCase()).includes(this.filters[key].toLowerCase()))
      })

      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filtered.length
      this.currentPage = 1
      return filtered.length > 0 ? filtered : [{
        categorie: '',
        fournisseur: '',
      }]

    }
  },
  watch: {},
  mounted() { },
  customButtons: {
    default: true,
  },
  created() {

    console.log('showprice', this.commercial.showprice)
    if (this.commercial.showprice == true || this.commercial.showprice == 'true') {
      this.fields = [
        { key: 'image', label: '', thStyle: { width: '100px' }, class: 'attachments' },
        { key: 'codearticle', label: 'Code article', sortable: true },
        { key: 'nom', label: 'Nom', sortable: true },
        { key: 'categorie', label: 'Collection', sortable: true },
        { key: 'fournisseur', label: 'Marque', sortable: true },
        { key: 'prix', label: 'Prix', sortable: true, class: 'text-center' }
      ]
    } else {
      this.fields = [
        { key: 'image', label: '', thStyle: { width: '100px' }, class: 'attachments' },
        { key: 'codearticle', label: 'Code article', sortable: true },
        { key: 'nom', label: 'Nom', thStyle: { width: '33%' }, sortable: true },
        { key: 'categorie', label: 'Collection', sortable: true },
        { key: 'fournisseur', label: 'Marque', sortable: true }
      ]
    }

    this.filters = {
      categorie: '',
      fournisseur: ''
    },

      this.initializeCategoriesArticles()
    this.initializeFournisseurs()
    this.initializeArticles()

  },
  methods: {
    cleanupvalidation($event) {
      console.log($event)
    },
    //Initialize Catégories d'articles
    async initializeCategoriesArticles() {
      //Récupération des catégories articles
      await this.localDB.find({ selector: { type: 'categoriesarticles' } }, (err, doc) => {
        if (err) {
          console.log('err', err)
        } else {
          // console.log('docCategoriesArticles', doc)
          for (let i = 0; i < doc.docs.length; i++) {
            this.categoriesarticles.push({
              label: doc.docs[i].nom,
              value: doc.docs[i].id,
            })
          }
          console.log('collections', this.categoriesarticles)
        }
      })
    },
    //Initialize Fournisseurs
    async initializeFournisseurs() {
      //Récupération des fournisseurs
      await this.localDB.find({ selector: { type: 'fournisseurs' } }, (err, doc) => {
        if (err) {
          console.log('err', err)
        } else {
          // console.log('docFournisseurs', doc)
          for (let i = 0; i < doc.docs.length; i++) {
            this.fournisseurs.push({
              label: doc.docs[i].nom,
              value: doc.docs[i].id,
            })
          }
          console.log('fournisseurs', this.fournisseurs)
        }
      })
    },
    //Initialize Articles
    async initializeArticles() {
      const mySelector = {};
      mySelector.type = 'articles';

      if (this.setting.saison != '' && this.commercial.showallsaison != 'true') {
        mySelector.categorie = this.setting.saison;
      }

      if (this.setting.filtre_articles_par_commerciaux == true || this.setting.filtre_articles_par_commerciaux == 'true') {
        mySelector.commerciaux = { $elemMatch: { $eq: localStorage.getItem('user') } };
      }
      
      await this.localDB.find({ selector: mySelector }, this.setArticles)
    },
    async setArticles(err, doc) {
      if (err) {
        console.log('err', err)
      }
      this.products = []
      console.log('products', doc)
      this.totalRows = doc.docs.length
      for (let i = 0; i < doc.docs.length; i++) {

        if (!doc.docs[i]._attachments) {
          // console.log('no attachement')
          this.image = require('@/assets/images/emptyimg.png')
        } else {
          console.log('attached', Object.keys(doc.docs[i]._attachments)[0])
          // await this.localDB.getAttachment(doc.docs[i]._id, Object.keys(doc.docs[i]._attachments)[0]).then((blobOrBuffer) => {
          await this.localDB.getAttachment(doc.docs[i]._id, Object.keys(doc.docs[i]._attachments)[0]).then(
            (blobOrBuffer) => {
              // console.log('url', URL.createObjectURL(blobOrBuffer))
              this.image = URL.createObjectURL(blobOrBuffer)
            },
            (error) => {
              console.log(error)
              this.image = require('@/assets/images/emptyimg.png')
            }
          );
        }

        var categorie
        await this.localDB.find({ selector: { type: 'categoriesarticles', id: doc.docs[i].categorie } }, (err, doc) => {
          if (err) {
            console.log('err', err)
          } else {
            categorie = doc.docs[0].nom
          }
        })

        var fournisseur
        await this.localDB.find({ selector: { type: 'fournisseurs', id: doc.docs[i].fournisseur } }, (err, doc) => {
          if (err) {
            console.log('err', err)
          } else {
            fournisseur = doc.docs[0].nom
          }
        })

        await this.products.push({
          key: doc.docs[i]._id,
          codearticle: doc.docs[i].codearticle,
          nom: doc.docs[i].nom,
          libelle: doc.docs[i].nom,
          categorie: categorie,
          fournisseur: fournisseur,
          image: this.image,
          prix: doc.docs[i].prix,
          quantite: 1,
          tva: doc.docs[i].tva,
        })

        this.categoriesName = [...new Set(this.products.map(item => item.categorie))]
        this.categoriesName.unshift('');

        this.souscategoriesName = [...new Set(this.products.map(item => item.fournisseur))]
        this.souscategoriesName.unshift('');

      }
      // console.log("product", this.products)
      this.totalRows = this.products.length
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    applyFilter() {
      if (this.filterInput.length >= 3) {
        this.filter = this.filterInput
      } else {
        this.filter = ''
      }
    },
    applyFilterEnter() {
      this.filter = this.filterInput
    },
    selectedCol(item) {
      this.$router.push({ name: 'viewarticle', params: { id: item.key } })
    }
  },
}
</script>

<style>
.btn-primary {
  margin-right: 12px;
}

.per-page-selector {
  width: 90px;
}

.btNopadding button {
  padding: 0;
}

table tbody tr {
  height: 60px;
}

@media (max-width: 767.98px) {
  .table.b-table.b-table-stacked-md>tbody>tr>[data-label]::before {
    text-align: left;
  }
}
</style>

<style lang="scss">
@import '~@core/scss/vue/libs/vue-select.scss';
</style>
